// import React, { useEffect, useState } from 'react';
// import { handleAmount } from '../../../../shared/extra';
// import { useDispatch, useSelector } from '../../../../imports/generalImport';
// import { Box, Typography, List, ListItem, Divider } from '../../../../imports/muiImport';
// import { calculatePayment } from '../customPaymentHook';
// import { couponAppliedReset } from '../../../../store/productDetails/action';

// function PaymentOrderReceipt({ isWalletAccepted }) {
//   const { discount, points, grossAmount, isCashbackProduct } = useSelector(
//     (state) => state.ProductDetail?.allData || {}
//   );
//   const DENOMINATION_STORE_DATA = useSelector((state) => state?.Denominations?.allData);
//   const COUPON_STORE_DATA = useSelector((state) => state?.Denominations?.couponData);

//   // const balance = useSelector((state) => state.UserBalance.allData);
//   const userProfile = useSelector((state) => state.UserProfile.allData?.data);
//   const balance = userProfile?.balance || 0;
//   const dispatch = useDispatch();

//   const [paymentData, setPaymentData] = useState({
//     TOTAL_VALUE: 0,
//     DISCOUNT: 0,
//     TOTAL_DISCOUNT: 0,
//     REWARD_POINTS: points || 0,
//     NET_PAY: 0,
//     WALLET_PAY_AMT: 0,
//     COUPON_DISCOUNT: COUPON_STORE_DATA?.discountValue,
//     WALLET_BALANCE: balance,
//   });

//   const netPayCalculateHandler = (calculationResult, couponDiscount) => {
//     if (isWalletAccepted) {
//       if (calculationResult.netPaymentAmt - balance > 0) {
//         return calculationResult.netPaymentAmt - (balance + couponDiscount);
//       } else {
//         return 0;
//       }
//     } else {
//       return calculationResult.netPaymentAmt - couponDiscount;
//     }
//   };

//   const walleyPayCalculateHandler = (calculationResult) => {
//     if (isWalletAccepted) {
//       if (calculationResult.netPaymentAmt >= balance) {
//         return balance;
//       } else {
//         return calculationResult.netPaymentAmt;
//       }
//     } else {
//       return 0;
//     }
//   };

//   useEffect(() => {
//     const calculationResult = calculatePayment(
//       DENOMINATION_STORE_DATA,
//       discount,
//       isCashbackProduct
//     );
//     const walleyPayCalculate = walleyPayCalculateHandler(calculationResult);
//     const netPayCalculate = netPayCalculateHandler(
//       calculationResult,
//       COUPON_STORE_DATA?.isCouponApplied ? COUPON_STORE_DATA?.discountValue || 0 : 0
//     );

//     const validateCoupon = () => {
//       const mn = COUPON_STORE_DATA?.conditions?.minPurchaseAmount || 0;
//       const mx = COUPON_STORE_DATA?.conditions?.maxPurchaseAmount || Infinity;
//       const ca = COUPON_STORE_DATA?.isCouponApplied;
//       const tg = calculationResult.totalGrossAmt;

//       if (ca && tg >= mn && tg <= mx) {
//         return true;
//       } else {
//         if (ca) {
//           dispatch(couponAppliedReset());
//         }
//         return false;
//       }
//     };

//     setPaymentData({
//       TOTAL_VALUE: calculationResult.totalGrossAmt,
//       DISCOUNT: calculationResult.discount,
//       TOTAL_DISCOUNT: calculationResult.totalDiscountAmt,
//       REWARD_POINTS: points || 0,
//       NET_PAY: netPayCalculate,
//       WALLET_BALANCE: balance,
//       COUPON_DISCOUNT: COUPON_STORE_DATA?.discountValue,
//       IS_SHOW_COUPON_DISCOUNT_COMPONENT: validateCoupon(),
//       WALLET_PAY_AMT: walleyPayCalculate,
//     });
//   }, [
//     dispatch,
//     netPayCalculateHandler,
//     walleyPayCalculateHandler,
//     DENOMINATION_STORE_DATA,
//     discount,
//     balance,
//     points,
//     grossAmount,
//     isCashbackProduct,
//     isWalletAccepted,
//     COUPON_STORE_DATA,
//     COUPON_STORE_DATA?.conditions?.minPurchaseAmount,
//     COUPON_STORE_DATA?.conditions?.maxPurchaseAmount,
//   ]);

//   return (
//     <Box>
//       <Box
//         sx={{
//           background: 'linear-gradient(180deg, #0B4AA2 0%, #0A3C84 100%)',
//           borderTopLeftRadius: 8,
//           borderTopRightRadius: 8,
//           px: 2,
//           py: 1,
//         }}
//       >
//         <Typography
//           variant="body1"
//           sx={{
//             color: 'white.main',
//             fontWeight: 500,
//             fontSize: '1.1rem',
//             textAlign: { xs: 'center', md: 'left' },
//           }}
//         >
//           Order Summary
//         </Typography>
//       </Box>

//       <Box
//         sx={{
//           border: '1.5px solid',
//           borderColor: 'divider',
//           borderTop: 'none',
//           borderBottomLeftRadius: 8,
//           borderBottomRightRadius: 8,
//           backgroundColor: 'white.main',
//           overflow: 'hidden',
//           width: '100%',
//           overflow: 'hidden',
//         }}
//       >
//         <List sx={{ p: 2 }}>
//           <ListItem disableGutters sx={{ py: 1 }}>
//             <Typography
//               sx={{
//                 flex: 1,
//                 fontSize: { xs: '1rem', md: '1.1rem' },
//                 textAlign: 'left',
//                 wordBreak: 'break-word',
//                 fontWeight: 400,
//                 color: 'textPrimary.main',
//               }}
//             >
//               Total Value
//             </Typography>
//             <Typography
//               sx={{
//                 flexGrow: 1,
//                 fontSize: { xs: '1rem', md: '1.1rem' },
//                 textAlign: 'right',
//                 wordBreak: 'break-word',
//                 fontWeight: 400,
//                 color: 'dark.main',
//               }}
//             >
//               ₹ {handleAmount(paymentData?.TOTAL_VALUE?.toFixed(2) || 0)}
//             </Typography>
//           </ListItem>
//           <Divider />

//           {/* Discount */}
//           <ListItem disableGutters sx={{ py: 1 }}>
//             <Typography
//               sx={{
//                 flex: 1,
//                 fontSize: { xs: '1rem', md: '1.1rem' },
//                 textAlign: 'left',
//                 wordBreak: 'break-word',
//                 fontWeight: 400,
//                 color: 'textPrimary.main',
//               }}
//             >
//               Discount ({discount || 0}%)
//             </Typography>
//             <Typography
//               sx={{
//                 flexGrow: 1,
//                 fontSize: { xs: '1rem', md: '1.1rem' },
//                 textAlign: 'right',
//                 wordBreak: 'break-word',
//                 fontWeight: 400,
//                 color: '#D32F2F',
//               }}
//             >
//               {paymentData?.TOTAL_DISCOUNT > 0 && '-'}₹{' '}
//               {handleAmount(paymentData?.TOTAL_DISCOUNT?.toFixed(2) || 0)}
//             </Typography>
//           </ListItem>
//           <Divider />

//           {/* Coupon Discount */}
//           {paymentData?.IS_SHOW_COUPON_DISCOUNT_COMPONENT && (
//             <>
//               <ListItem disableGutters sx={{ py: 1 }}>
//                 <Typography
//                   sx={{
//                     flex: 1,
//                     fontSize: { xs: '1rem', md: '1.1rem' },
//                     textAlign: 'left',
//                     wordBreak: 'break-word',
//                     fontWeight: 400,
//                     color: 'textPrimary.main',
//                   }}
//                 >
//                   Coupon Applied
//                 </Typography>
//                 <Typography
//                   sx={{
//                     flexGrow: 1,
//                     fontSize: { xs: '1rem', md: '1.1rem' },
//                     textAlign: 'right',
//                     wordBreak: 'break-word',
//                     fontWeight: 400,
//                     color: '#D32F2F',
//                   }}
//                 >
//                   {paymentData?.COUPON_DISCOUNT > 0 && '-'}₹{' '}
//                   {handleAmount(paymentData?.COUPON_DISCOUNT?.toFixed(2) || 0)}
//                 </Typography>
//               </ListItem>
//               <Divider />
//             </>
//           )}

//           {/* Total Payout */}
//           <ListItem disableGutters sx={{ py: 1.5 }}>
//             <Typography
//               sx={{
//                 flex: 1,
//                 fontSize: { xs: '1rem', md: '1.2rem' },
//                 textAlign: 'left',
//                 wordBreak: 'break-word',
//                 fontWeight: 500,
//                 color: 'green.main',
//               }}
//             >
//               Total Payout
//             </Typography>
//             <Typography
//               sx={{
//                 flexGrow: 1,
//                 fontSize: { xs: '1rem', md: '1.2rem' },
//                 textAlign: 'right',
//                 wordBreak: 'break-word',
//                 fontWeight: 500,
//                 color: 'green.main',
//               }}
//             >
//               ₹{' '}
//               {paymentData?.NET_PAY >= 0 ? handleAmount(paymentData?.NET_PAY?.toFixed(2) || 0) : 0}
//             </Typography>
//           </ListItem>
//         </List>
//       </Box>
//     </Box>
//   );
// }

// export default PaymentOrderReceipt;

// NEW CODE - Optimized
import React from 'react';
import { handleAmount } from '../../../../shared/extra';
import { useDispatch, useSelector } from '../../../../imports/generalImport';
import { Box, Typography, List, ListItem, Divider } from '../../../../imports/muiImport';
import { calculatePayment } from '../customPaymentHook';
import { couponAppliedReset } from '../../../../store/productDetails/action';

function PaymentOrderReceipt({ isWalletAccepted }) {
  const dispatch = useDispatch();

  const { discount, points, isCashbackProduct } = useSelector(
    (state) => state.ProductDetail?.allData || {}
  );

  const DENOMINATION_STORE_DATA = useSelector((state) => state?.Denominations?.allData);

  const COUPON_STORE_DATA = useSelector((state) => state?.Denominations?.couponData);

  const userProfile = useSelector((state) => state.UserProfile.allData?.data);

  const balance = userProfile?.balance || 0;

  /* -------------------- PAYMENT CALCULATION -------------------- */
  const paymentData = React.useMemo(() => {
    const calculationResult = calculatePayment(
      DENOMINATION_STORE_DATA,
      discount,
      isCashbackProduct
    );


    const couponDiscount = () => {
      // console.log('COUPON_STORE_DATA', COUPON_STORE_DATA);
      let couponAmount = 0;
      const netPay = calculationResult?.totalGrossAmt - calculationResult?.totalDiscountAmt;

      if (COUPON_STORE_DATA?.isCouponApplied) {

        if (COUPON_STORE_DATA?.discountType === "PERCENTAGE") {
          const dis = (netPay * COUPON_STORE_DATA?.discountValue) / 100;
          couponAmount = dis;

          if (COUPON_STORE_DATA?.maxDiscount <= dis) {
            couponAmount = COUPON_STORE_DATA?.maxDiscount;
          }
        }

        if (COUPON_STORE_DATA?.discountType === "FLAT") {
          couponAmount = COUPON_STORE_DATA?.discountValue;
        }
      }

      return couponAmount;
    };

    const walletPayAmt = isWalletAccepted ? Math.min(balance, calculationResult.netPaymentAmt) : 0;

    const netPay = isWalletAccepted
      ? Math.max(calculationResult.netPaymentAmt - (walletPayAmt + couponDiscount()), 0)
      : calculationResult.netPaymentAmt - couponDiscount();

    const minAmount = COUPON_STORE_DATA?.conditions?.minPurchaseAmount || 0;
    const maxAmount = COUPON_STORE_DATA?.conditions?.maxPurchaseAmount || Infinity;

    const isCouponValid =
      COUPON_STORE_DATA?.isCouponApplied &&
      calculationResult.totalGrossAmt >= minAmount &&
      calculationResult.totalGrossAmt <= maxAmount;

    return {
      TOTAL_VALUE: calculationResult.totalGrossAmt,
      TOTAL_DISCOUNT: calculationResult.totalDiscountAmt,
      NET_PAY: netPay,
      WALLET_PAY_AMT: walletPayAmt,
      WALLET_BALANCE: balance,
      COUPON_DISCOUNT: couponDiscount(),
      REWARD_POINTS: points || 0,
      IS_SHOW_COUPON_DISCOUNT_COMPONENT: isCouponValid,
    };
  }, [
    DENOMINATION_STORE_DATA,
    discount,
    isCashbackProduct,
    isWalletAccepted,
    balance,
    points,
    COUPON_STORE_DATA,
  ]);

  /* -------------------- COUPON INVALID RESET -------------------- */
  React.useEffect(() => {
    if (COUPON_STORE_DATA?.isCouponApplied && !paymentData.IS_SHOW_COUPON_DISCOUNT_COMPONENT) {
      dispatch(couponAppliedReset());
    }
  }, [COUPON_STORE_DATA?.isCouponApplied, paymentData.IS_SHOW_COUPON_DISCOUNT_COMPONENT, dispatch]);

  /* -------------------- UI -------------------- */
  return (
    <Box>
      {/* Header */}
      <Box
        sx={{
          background: 'linear-gradient(180deg, #0B4AA2 0%, #0A3C84 100%)',
          borderTopLeftRadius: 8,
          borderTopRightRadius: 8,
          px: 2,
          py: 1,
        }}
      >
        <Typography
          sx={{
            color: 'white.main',
            fontWeight: 500,
            fontSize: '1.1rem',
            textAlign: { xs: 'center', md: 'left' },
          }}
        >
          Order Summary
        </Typography>
      </Box>

      {/* Body */}
      <Box
        sx={{
          border: '1.5px solid',
          borderColor: 'divider',
          borderTop: 'none',
          borderBottomLeftRadius: 8,
          borderBottomRightRadius: 8,
          backgroundColor: 'white.main',
        }}
      >
        <List sx={{ p: 2 }}>
          {/* Total Value */}
          <ListItem disableGutters sx={{ py: 1 }}>
            <Typography flex={1}>Total Value</Typography>
            <Typography>₹ {handleAmount(paymentData.TOTAL_VALUE.toFixed(2))}</Typography>
          </ListItem>
          <Divider />

          {/* Discount */}
          <ListItem disableGutters sx={{ py: 1 }}>
            <Typography flex={1}>{isCashbackProduct ? 'Cashback' : `Discount (${discount || 0}%)`}</Typography>
            <Typography color="#D32F2F">
              ₹ {handleAmount(paymentData.TOTAL_DISCOUNT.toFixed(2))}
            </Typography>
          </ListItem>
          <Divider />

          {/* Coupon */}
          {paymentData?.IS_SHOW_COUPON_DISCOUNT_COMPONENT && (
            <>
              <ListItem disableGutters sx={{ py: 1 }}>
                <Typography flex={1}>Coupon Applied</Typography>
                <Typography color="#D32F2F">
                  ₹ {handleAmount(paymentData?.COUPON_DISCOUNT?.toFixed(2))}
                </Typography>
              </ListItem>
              <Divider />
            </>
          )}

          {/* Wallet */}
          {paymentData?.WALLET_PAY_AMT > 0 && (
            <>
              <ListItem disableGutters sx={{ py: 1 }}>
                <Typography flex={1}>Wallet</Typography>
                <Typography color="#D32F2F">
                  ₹ {handleAmount(paymentData.WALLET_PAY_AMT.toFixed(2))}
                </Typography>
              </ListItem>
              <Divider />
            </>
          )}

          {/* Net Pay */}
          <ListItem disableGutters sx={{ py: 1.5 }}>
            <Typography flex={1} fontWeight={500} color="green.main">
              Total Payout
            </Typography>
            <Typography fontWeight={500} color="green.main">
              ₹ {handleAmount(Math.max(paymentData.NET_PAY, 0).toFixed(2))}
            </Typography>
          </ListItem>
        </List>
      </Box>
    </Box>
  );
}

export default PaymentOrderReceipt;
